<template>
  <div>
    <div>
      <div v-if="!isEmpty(answers)">
        <div class="columns is-vcentered is-mobile" style="padding: 0 10px; margin-bottom: 0;" v-for="(answer, key) in answers" :key="key">
          <div class="column is-narrow">#{{ key + 1 }}</div>
          <div class="column is-narrow is-hidden-mobile">
            <figure class="image is-24x24 is-circle">
              <avatar v-if="group.type == 'ACADEMIC'" :avatar_url="!isEmpty(answer.groupMember.account) && !isEmpty(answer.groupMember.account.user) && !isEmpty(answer.groupMember.account.user.media) && !isEmpty(answer.groupMember.account.user.media.images) && !isEmpty(answer.groupMember.account.user.media.images.thumb) && !isEmpty(answer.groupMember.account.user.media.images.thumb.link) ? answer.groupMember.account.user.media.images.thumb.link : ''"></avatar>

              <avatar v-else :avatar_url="!isEmpty(answer.groupMember.user) && !isEmpty(answer.groupMember.user.media) && !isEmpty(answer.groupMember.user.media.images) && !isEmpty(answer.groupMember.user.media.images.thumb) && !isEmpty(answer.groupMember.user.media.images.thumb.link) ? answer.groupMember.user.media.images.thumb.link : ''"></avatar>
            </figure>
          </div>
          <div class="column">
            <span v-if="group.type == 'ACADEMIC' && !isEmpty(answer.groupMember.account)">{{ answer.groupMember.account.name }}</span>
            <span v-else>{{ answer.groupMember.user.name }}</span>
          </div>
          <div class="column has-text-centered has-text-primary is-narrow">{{ answer.grade || '-' }}</div>
          <div class="column is-narrow">
            <button class="button is-text is-small has-text-link" @click.prevent="toGrading(answer, key)">Lihat</button>
          </div>
        </div>

        <pagination v-if="!loading_get_answers" :dataProvider="dataProvider" :clickHandler="getAllAnswers" :infinity_scroll="true"></pagination>

        <div v-if="loading_get_answers">
          <spinner-loading></spinner-loading>
        </div>
      </div>

      <div class="columns is-vcentered is-mobile" v-else>
        <div class="column">
          <p class="has-text-grey has-text-centered"><small>Belum ada yang mengumpulkan.</small></p>
        </div>
      </div>
    </div>

    <b-modal v-if="!isEmpty(selected_answer) && !isEmpty(selected_answer.groupMember)" :active.sync="show_answer_modal" has-modal-card full-screen>
      <form @submit.prevent="setGrade">
        <div class="modal-card" style="width: auto">
          <header class="modal-card-head is-bg-primary">
            <p class="modal-card-title has-text-white">
              #{{ current_key + 1 }}. Jawaban <span v-if="group.type == 'ACADEMIC'">{{ selected_answer.groupMember.account.name }}</span><span v-if="group.type != 'ACADEMIC'">{{ selected_answer.groupMember.user.name }}</span>
            </p>
            <a href="#" class="modal-card-header-icon" aria-label="more options" @click.prevent="selected_answer = null">
              <span class="icon has-text-white">
                <b-icon icon="close"></b-icon>
              </span>
            </a>
          </header>
          <section class="modal-card-body">
            <div :class="{'is-disabled': loading_set_grade}" :disabled="loading_set_grade">
              <b-field label="Nama">
                <b-input v-if="group.type == 'ACADEMIC'" :placeholder="selected_answer.groupMember.account.name" disabled :value="selected_answer.groupMember.account.name"></b-input>
                <b-input v-else :placeholder="selected_answer.groupMember.user.name" disabled :value="selected_answer.groupMember.user.name"></b-input>
              </b-field>
              <b-field label="NIM" v-if="group.type == 'ACADEMIC'">
                <b-input :placeholder="selected_answer.groupMember.account.userUniversityId" disabled :value="selected_answer.groupMember.account.userUniversityId"></b-input>
              </b-field>
              <!-- <b-field label="Email" v-if="group.type != 'ACADEMIC'">
                <b-input :placeholder="selected_answer.groupMember.user.email" disabled :value="selected_answer.groupMember.user.email"></b-input>
              </b-field> -->
              <b-field label="Jawaban">
                <pre style="background: transparent; padding: 0; white-space: pre-line; margin-bottom: 0; font-family: inherit;" v-html="selected_answer.answer"></pre>
              </b-field>
              <b-field label="Berkas" v-if="!isEmpty(selected_answer.newMedias)">
                <div>
                  <div class="middle-content" style="margin-bottom: 0;">
                    <div class="tugas__content-timeline">
                      <div class="content" style="padding: 0; border: none;">
                        <div class="keterangan" style="margin: 0; width: 100%;">
                          <div class="file-download" v-for="(media, key) in selected_answer.newMedias" :key="key" style="padding: 5px .65rem 5px 0;" :style="key == 0 ? 'margin-top: 0 !important;' : 'margin-top: 7px !important;'">
                            <span>
                              &nbsp;&nbsp;<icon-collection :media="media" size="is-24x24"></icon-collection>
                              <a href="" @click.prevent="showPreview(media)">{{ media.name }}</a>
                            </span>
                            <button class="button is-text" v-if="['video', 'document', 'other'].indexOf(media.type) > -1" @click.prevent="download(media, group.id)">Unduh</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- <div class="columns is-mobile is-gapless is-vcentered" v-for="(media, key) in selected_answer.newMedias" :key="key" style="margin-bottom: 5px;">
                    <div class="column is-narrow tooltip" data-tooltip="Download" @click.prevent="download(media)" v-if="!isEmpty(media)" style="margin-right: 10px;">
                      <button class="button"><span class="icon"><i class="fas fa-download"></i></span></button>
                    </div>
                    <div class="column is-narrow" v-if="!isEmpty(media)">
                      <div class="columns is-mobile is-vcentered is-gapless">
                        <div class="column is-narrow" style="margin-right: 10px;" @click.prevent="showPreview(media)">
                          <icon-collection :media="media" size="is-32x32"></icon-collection>
                        </div>
                        <div class="column">
                          <span><small>{{ media.name }}</small></span>
                        </div>
                      </div>
                    </div>
                  </div> -->
                </div>
              </b-field>
              <b-field v-if="!isEmpty(selected_answer.totalMissingMedias) && selected_answer.totalMissingMedias > 0">
                <template slot="label">
                  <span class="has-text-info">Berkas perlu diunggah ulang</span>
                  <b-tooltip type="is-dark" label="Berkas yang diunggah tidak valid / rusak">
                    <b-icon size="is-small" icon="help-circle-outline"></b-icon>
                  </b-tooltip>
                </template>

                <div>
                  <div class="columns is-mobile is-gapless is-vcentered" style="margin-bottom: 5px;">
                    <div class="column">
                      <p class="has-text-grey">{{ selected_answer.totalMissingMedias }} Berkas Rusak</p>
                    </div>
                  </div>
                </div>
              </b-field>
              <b-field label="Nilai">
                <b-input type="number" min="0" max="100" placeholder="Nilai" v-model="selected_answer.grade" size="is-medium"></b-input>
              </b-field>
              <b-field label="Feedback">
                <txteditor ref="feedback" :editText="true" :onUpdate="(text) => selected_answer['feedback'] = text" :text="selected_answer.feedback"></txteditor>
              </b-field>
            </div>
          </section>
          <footer class="modal-card-foot">
            <div class="columns is-gapless" style="width: 100%;">
              <div class="column is-narrow">
                <button type="button" class="button tooltip" :data-tooltip="`Ke Jawaban #${prev_key + 1}`" @click.prevent="prev(prev_answer, prev_key)" v-if="!isEmpty(prev_answer)" style="margin-right: 10px !important;" :class="{'is-loading': loading_set_grade}" :disabled="loading_set_grade">
                  <span>Sebelumnya</span>
                </button>
              </div>
              <div class="column">
                <button type="button" class="button tooltip" :data-tooltip="`Ke Jawaban #${next_key + 1}`" @click.prevent="next(next_answer, next_key)" v-if="!isEmpty(next_answer)" :class="{'is-loading': loading_set_grade}" :disabled="loading_set_grade">
                  <span>Berikutnya</span>
                </button>
              </div>
              <div class="column is-narrow">
                <button type="submit" class="button is-primary" :class="{'is-loading': loading_set_grade}" :disabled="loading_set_grade">
                  <span>Simpan <span>& Lanjut</span></span>
                </button>
              </div>
            </div>
          </footer>
        </div>
      </form>
    </b-modal>

    <preview-modal v-if="!isEmpty(selected_media)" :onHide="() => selected_media = null" :media="selected_media"></preview-modal>
    <preview-modal v-if="!isEmpty(preview_media)" :onHide="() => preview_media = null" :media="preview_media"></preview-modal>
  </div>
</template>

<script>
import { TEACHER_QUESTION } from '~/consts';
import TextEditor from '~/components/TextEditor';
import TRACKER_MIXIN from '~/mixins/tracker';

export default {
  mixins: [TRACKER_MIXIN],

  components: {
    'txteditor': TextEditor
  },

  props: {
    id: {
      type: Number,
      required: true
    },
    group: {
      type: Object,
      required: true
    },
    answer_sort_by: {
      type: String,
      required: false
    },
    answer_search_keyword: {
      type: String,
      required: false
    },
    setCountMember: {
      type: Function,
      default: () => {}
    }
  },

  mounted() {
    this.getAllAnswers();
  },

  data() {
    return {
      loading_set_grade: false,
      loading_get_answers: false,
      show_answer_modal: false,
      answers: [],
      selected_answer: null,
      selected_media: null,
      prev_answer: null,
      prev_key: null,
      current_key: null,
      next_answer: null,
      next_key: null,
      preview_media: null,
      dataProvider: {
        page: {
          current: 1,
          limit: 10
        },
        sort: [
          {criteria: 'created_at', order: 'ASC'}
        ]
      }
    }
  },

  watch: {
    answer_sort_by (val) {
      let custom_filter = { key: "sort_by", value: val };
      this.getAllAnswers(true, custom_filter);
    },
    answer_search_keyword (val) {
      let custom_filter = { key: "keyword", value: val };
      this.getAllAnswers(true, custom_filter);
    }
  },

  methods: {
    async prev(answer, key) {
      await this.setGrade()
      Vue.nextTick(() => {
        let ans = collect(this.answers).where('id', '==', answer.id).first()
        this.showAnswer(ans, key)
        this.$refs.feedback.editor.setContent(ans.feedback)
      })
    },
    async next(answer, key) {
      await this.setGrade()
      Vue.nextTick(() => {
        let ans = collect(this.answers).where('id', '==', answer.id).first()
        this.showAnswer(ans, key)
        this.$refs.feedback.editor.setContent(ans.feedback)
      })
    },
    toGrading(answer) {
      const group_type = this.group.type == "ACADEMIC" ? "classes" : "groups";
      this.$router.push({
        name: `panel-${group_type}-id-sections-section_id-learningmaterial_id-grading`,
        params: { ...this.$route.params },
        query: {
          answer: answer.id
        }
      });
    },
    showAnswer(answer, key) {
      const vm = this;

      let answers = collect(vm.answers);
      let prev_answer = answers.filter((i, k) => {
        if (k == (key - 1) && i.id != answer.id) {
          vm.prev_key = (key - 1);

          return true;
        }

        return false;
      }).first();

      let next_answer = answers.filter((i, k) => {
        if (k == (key + 1) && i.id != answer.id) {
          vm.next_key = (key + 1);

          return true;
        }

        return false;
      }).first();

      vm.current_key = key
      /*vm.selected_answer = _.cloneDeep(answer)*/
      vm.selected_answer = this.getSelectedAnswer(answer)
      vm.prev_answer = _.cloneDeep(prev_answer)
      vm.next_answer = _.cloneDeep(next_answer)
      vm.show_answer_modal = true;
    },
    getAllAnswers(refresh = false, custom_payload = null) {
      const vm = this;

      vm.loading_get_answers = true

      if (refresh) {
        vm.dataProvider.page['current'] = 1;
      }

      let payload = {};
      payload['dataProvider'] = JSON.stringify(vm.dataProvider);

      if (!this.isEmpty(custom_payload)) {
          payload[custom_payload.key] = custom_payload.value
          payload['sort_by_value'] = 'ASC'
      }

      this.$axios.post(TEACHER_QUESTION.GET_ALL_ANSWERS(this.id), payload)
        .then(({ data }) => {
          if (data.applicationSystem.code == 0) {
            let answers = data.data.data;
            if (!refresh) {
              answers = vm.answers.concat(answers);
            }

            vm.answers = answers;
            this.setCountMember(answers.length);

            vm.dataProvider = data.data.dataProvider
          } else {
            this.$buefy.toast.open({
              message: data.applicationSystem.message,
              type: 'is-danger'
            });
          }

          vm.loading_get_answers = false
        })
        .catch(() => {
          vm.loading_get_answers = false
        })
    },
    async setGrade() {
      const vm = this;

      vm.loading_set_grade = true;

      try {
        let {data} = await this.$axios.post(TEACHER_QUESTION.SET_GRADE(vm.selected_answer.id), {
          grade: vm.selected_answer.grade,
          feedback: vm.selected_answer.feedback
        })

        if (data.applicationSystem.code == 0) {
          vm.answers = collect(vm.answers).map((a) => {
            if (vm.selected_answer.id == a.id) {
              a['grade'] = vm.selected_answer.grade
              a['feedback'] = vm.selected_answer.feedback
            }

            return a;
          }).toArray()
          vm.trackSubmitAssignmentGrade(!this.isEmpty(data.data.feedback) ? true : false);
          this.$buefy.toast.open({
            message: data.applicationSystem.message,
            type: 'is-dark'
          });
        } else {
          this.$buefy.toast.open({
            message: data.applicationSystem.message,
            type: 'is-danger'
          });
        }

        vm.loading_set_grade = false
      } catch (error) {
        vm.loading_set_grade = false
      }
    },
    showPreview(media) {
      if (['document', 'link'].indexOf(media.type) > -1) {
        if (media.type == 'link' && !this.isEmpty(media.link)) {
          window.open(media.link,'_blank');
        } else if (media.type == 'document' && !this.isEmpty(media.file) && !this.isEmpty(media.file.link) && media.storageType == null) {
          this.openDocument(media.file.link);
        } else if (media.storageType == 'google_drive' && media.type == 'document' && !this.isEmpty(media.values)) {
          window.open(media.values.webViewLink, "_blank");
        }
      } else if (['image', 'youtube'].indexOf(media.type) > -1) {
        this.preview_media = media
      }
    },
    getSelectedAnswer(answer){
      const data_answer = _.cloneDeep(answer);
      data_answer.newMedias = data_answer.newMedias.map((el, i)=>{
        if(el.images){
          el.thumb_url = el.images.thumb.link;
        }
        return el;
      })
      return data_answer;
    }
  }
}
</script>
